import styles from "./index.module.less";
import qrcode from "qrcode";
import {useState,useEffect} from "react";
import {Util} from "@xt/xtbase";
const {getUrl} = Util;
import logoIcon from "./img/logo.png";
export default function QrCode({ content, logo, size, margin, isShowLogo }) {
  const [qrCodeUrl, setQrCodeUrl] = useState("");
  useEffect(()=>{
    qrcode.toDataURL(content || getUrl("/app"))
    .then((url) => {
      setQrCodeUrl(url);
    })
    .catch((err) => {
      console.error(err);
    });
  },[]);
  return (
    <div className={styles["qrcode-container"]}>
      <img src={qrCodeUrl} style={{
        "width":(size || 100)+"px",
        "height":(size || 100)+"px",
        "margin":(margin || 0)+"px",
        "display": "inline-block",
      }} alt="qrcode" />
      {isShowLogo ? <img className={styles.logo} src={logo || logoIcon} alt="" /> : null}
    </div>
  );
}